<template>
    <div>
        <label class="form-label">{{ $t('Expiration') }}</label>
        <div class="tw:flex tw:flex-wrap tw:gap-2 tw:mb-3">
            <button
                v-for="option in presetOptions"
                :key="option.value"
                type="button"
                class="btn btn-sm"
                :class="selected === option.value ? 'btn-primary' : 'btn-outline-secondary'"
                @click="selectPreset(option.value)"
            >
                {{ option.label }}
            </button>
        </div>

        <div v-if="selected === 'custom'" class="tw:mt-2">
            <label for="expires_at" class="form-label">{{ $t('Expiration date') }}</label>
            <input
                type="date"
                id="expires_at"
                class="form-control"
                :min="minDate"
                :max="maxDate"
                v-model="customDate"
            >
        </div>

        <input type="hidden" :name="name" :value="computedValue">
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'

const { t } = useI18n()

const props = defineProps({
    name: {
        type: String,
        default: 'expires_at',
    },
    initial: {
        type: String,
        default: null,
    },
})

const selected = ref(props.initial ? 'custom' : '30')
const customDate = ref(props.initial ?? '')

const presetOptions = computed(() => [
    { value: '7', label: '7 ' + t('days') },
    { value: '30', label: '30 ' + t('days') },
    { value: '60', label: '60 ' + t('days') },
    { value: '90', label: '90 ' + t('days') },
    { value: 'custom', label: t('Custom') },
    { value: 'never', label: t('No expiration') },
])

const minDate = computed(() => dayjs().add(1, 'day').format('YYYY-MM-DD'))
const maxDate = computed(() => dayjs().add(1, 'year').format('YYYY-MM-DD'))

const computedValue = computed(() => {
    if (selected.value === 'never') {
        return ''
    }
    if (selected.value === 'custom') {
        return customDate.value
    }
    return dayjs().add(parseInt(selected.value), 'day').format('YYYY-MM-DD')
})

function selectPreset(value) {
    selected.value = value
    if (value !== 'custom') {
        customDate.value = ''
    }
}
</script>
